import { Divider, Skeleton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "../analytics/overview/overview.css";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

function ProcessorAndPaymentCategoriesCard({
  gmvPspData,
  paymentMethodReport,
  paymentData,
  value,
  logo,
  title,
  showLeftIcon,
  showRightIcon,
  backgroundColor,
  loading
}) {
  const totalPayment = paymentMethodReport?.reduce(
    (sum, item) => sum + item.gmv,
    0
  );
  const updatedPaymentData = paymentMethodReport?.map((item) => ({
    ...item,
    percentage: (item.gmv / totalPayment) * 100,
  }));

  const totalGMV = gmvPspData?.reduce((sum, item) => sum + item.gmv, 0);
  const updatedGMVData = gmvPspData.map((item) => ({
    ...item,
    percentage: (item.gmv / totalGMV) * 100,
  }));

  for (const item of updatedGMVData) {
    const matchingPspCode = logo?.find((psp) => psp.pspCode === item.pspCode);
    if (matchingPspCode) {
      item.logoUrl = matchingPspCode.pspLogoUrl;
      item.title = matchingPspCode.title;
    }
  }

  const [currentValue, setCurrentValue] = useState("Value");

  const handleLeftArrowClick = () => {
    if (currentValue === "Value") {
      setCurrentValue("% of Value");
    } else if (currentValue === "% of Value") {
      setCurrentValue("Count");
    } else if (currentValue === "Count") {
      setCurrentValue("Value");
    }
  };

  const handleRightArrowClick = () => {
    if (currentValue === "Value") {
      setCurrentValue("% of Value");
    } else if (currentValue === "% of Value") {
      setCurrentValue("Count");
    } else if (currentValue === "Count") {
      setCurrentValue("Value");
    }
  };

  const sortPaymentDataByValue = (data) => {
    if (currentValue === "Count") {
      return [...data].sort((a, b) => b.paymentMethodCount - a.paymentMethodCount);
    } else if (currentValue === "Value") {
      return [...data].sort((a, b) => b.gmv - a.gmv);
    } else {
      return [...data].sort((a, b) => b.percentage - a.percentage);
    }
  };
  const sortGMVDataByValue = (data) => {
    if (currentValue === "Count") {
      return [...data].sort((a, b) => b.pspCodeCount - a.pspCodeCount);
    } else if (currentValue === "Value") {
      return [...data].sort((a, b) => b.gmv - a.gmv);
    } else {
      return [...data].sort((a, b) => b.percentage - a.percentage);
    }
  };

  const sortedPaymentDataByValue = sortPaymentDataByValue(updatedPaymentData);
  const sortedGmvDataByValue = sortGMVDataByValue(updatedGMVData);

  const paymentMethodLogos = (paymentMethod) => {
    switch (paymentMethod) {
      case "Card":
        return <img src="assets/paymentIcons/CardsLogo.svg" alt="logo" className="paymentLogo" style={{ objectFit: "contain" }} />;
      case "Wallet":
        return <img src="assets/paymentIcons/WalletsLogo.svg" alt="logo" className="paymentLogo" style={{ objectFit: "contain" }} />;
      case "NetBanking":
        return <img src="assets/paymentIcons/NetBankingLogo.svg" alt="logo" className="paymentLogo" style={{ objectFit: "contain" }} />;
      case "Upi":
        return <img src="assets/paymentIcons/UPILogo.svg" alt="logos" className="paymentLogo" style={{ objectFit: "contain" }} />;
      case "Emi":
        return <img src="assets/paymentIcons/EMILogo.svg" alt="logo" className="paymentLogo" style={{ objectFit: "contain" }} />;
      case "BuyNowPayLater":
        return <img src="assets/paymentIcons/BNPL.svg" alt="logo" className="paymentLogo" style={{ objectFit: "contain" }} />;
      default:
        return null;
    }
  };
  return (
    <div
      className="paymentDiv"
      style={{ background: backgroundColor, border: "1px solid #ECECEC" }}
    >
      {loading ? (
        <div>
          <Skeleton variant="rectangular" width="100%" height={377} />
        </div>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography className="bodyB2SemiBold paymentHeading">
              {title}
            </Typography>
            <div>
              <Typography
                className="bodyB2SemiBold "
                style={{ display: "flex", cursor: "pointer", whiteSpace: "nowrap" }}
              >
                {showLeftIcon && (
                  <MdKeyboardArrowLeft
                    onClick={handleLeftArrowClick}
                    style={{ marginTop: "2px" }}
                  />
                )}
                {currentValue}
                {showRightIcon && (
                  <MdKeyboardArrowRight
                    onClick={handleRightArrowClick}
                    style={{ marginTop: "2px" }}
                  />
                )}
              </Typography>
            </div>
          </div>
          <Divider className="paymentDivider" />
          <div
            style={{
              overflowY: "auto",
              maxHeight: "400px",
              height: "300px",
              marginTop: "12px",
            }}
          >
            {title === "Transactions by Categories" ? (
              sortedPaymentDataByValue?.length > 0 ? (
                sortedPaymentDataByValue?.map((item, idx) => {
                  return (
                    <div className="payemntDataDiv" key={idx}>
                      <div className="displayDirectionRow">
                        {paymentMethodLogos(item.paymentMethod)}
                        <Typography className="labelMedium paymentText">
                          {item?.paymentMethodLocale}
                        </Typography>
                      </div>
                      <Typography className="bodyB2SemiBold paymentText">
                        {currentValue === "Value" ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              paddingRight: "4px",
                            }}
                          >
                            <span style={{ marginTop: "0.5px" }}>
                              {" "}
                              {item?.gmvLocaleFull}
                            </span>
                          </div>
                        ) : currentValue === "Count" ? (
                          <div>{item?.paymentMethodCountLocale}</div>
                        ) : (
                          <div>{item?.percentage.toFixed(1)}&nbsp;%</div>
                        )}
                      </Typography>
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "130px",
                  }}
                >
                  <Typography className="subHeaderMedium">
                    No data to display
                  </Typography>
                  <Typography
                    className="bodyB2Medium"
                    style={{ marginTop: "12px" }}
                  >
                    Please make a different filter selection
                  </Typography>
                </div>
              )
            ) : sortedGmvDataByValue?.length > 0 ? (
              sortedGmvDataByValue?.map((item, idx) => {
                return (
                  <div className="payemntDataDiv" key={idx}>
                    <div className="displayDirectionRow">
                      {item?.pspCode === "NONE" || item?.pspCode === "None" ? (
                        <div>
                          <img
                            src="assets/paymentIcons/UnknownLogo.svg"
                            alt="logo"
                            className="paymentLogo"
                            style={{ objectFit: "contain", marginTop: "-10px" }}
                          />
                        </div>
                      ) : item?.logoUrl ? (
                        <>
                          <img
                            src={item.logoUrl}
                            alt="logo"
                            className="paymentLogo"
                            style={{
                              objectFit: "contain",
                              mixBlendMode: "multiply",
                              height: "22px",
                              width: "22px",
                              marginTop: "-3px",
                            }}
                            loading="lazy"
                          />
                        </>
                      ) : null}
                      <Typography
                        className="labelMedium  paymentText"
                        style={{ marginTop: "2px" }}
                      >
                        {item.pspCode === "NONE" || item.pspCode === "None" ? (
                          <p>Unknown</p>
                        ) : (
                          <div>{item?.pspCodeLocale}</div>
                        )}
                      </Typography>
                    </div>
                    <Typography className="bodyB2SemiBold paymentText">
                      {currentValue === "Value" ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingRight: "4px",
                          }}
                        >
                          {item?.gmvLocaleFull}
                        </div>
                      ) : currentValue === "Count" ? (
                        <div>{item?.pspCodeCountLocale}</div>
                      ) : (
                        <div>{item.percentage.toFixed(1)}&nbsp;%</div>
                      )}
                    </Typography>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "130px",
                }}
              >
                <Typography className="subHeaderMedium">
                  No data to display
                </Typography>
                <Typography className="bodyB2Medium" style={{ marginTop: "12px" }}>
                  Please make a different filter selection
                </Typography>
              </div>
            )}
          </div> </>)}
    </div>
  );
}

export default ProcessorAndPaymentCategoriesCard;
